import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class VariantsService {
  fetchVariants = (params) => {
    return fetch(config.config.endpointUrls.fetchVariants(params), {
      method: 'GET'
    })
  }
}

export default new VariantsService()



// WEBPACK FOOTER //
// ../src/services/variantsService/variantsService.js